module.exports = __webpack_public_path__ + "media/src/images/mails/f59b00-daf61d8a981aa8075bdb9dd55b94ca34.png";